import React, {Component} from 'react';
import {Modal} from 'react-bootstrap';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';

var Config = require('../../../config');

class ModalFamiliar extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);

		this.state = {
			show: false,
			id:"",
			name:"",
			relationship:"",
			address:"",
			state:"",
			mpio:"",
			cp:"",
			tel_cel:"",
			tel_casa:"",
			relationships:[],
			disabled:false,
			hb:"",
			hto:"",
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	handleShow(){
		//parentesco
		fetch(Config.default.apiGateway.URL+'lookups?type=FAMILIAR_RELATIONSHIP&option=actives&order=true',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
        }})
		.then(response => {
			this.setState({
		      relationships: response
		    });
		})

		var id = this.props.match.params.id;
		this.setState({show:true,/*disabled:id !== undefined ? true : false*/});
		
	}

	handleClose(){
		this.setState({show:false});
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});
	}

	handleSubmit(e){
		e.preventDefault();
		var obj = {
			full_name:this.state.name,
			patient_relationship:this.state.relationship,
			address: this.state.address,
			state: this.state.state,
			province: this.state.mpio,
			cp: this.state.cp,
			home_phone:this.state.tel_casa,
			cell_phone: this.state.tel_cel,
			hematocrito:this.state.hto,
			hemoglobina:this.state.hb
		};

		if(this.props.match.params.id !== undefined){
			if(this.state.id !== ""){
				obj.id = this.state.id;
			}
			
			obj.petition_id = this.props.match.params.id;

		}

		if(this.isValidForm()){
			this.props.setFamiliar(obj);
			this.handleClose();
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}

			
	}

	isValidForm() {
		var ctrls = [];
		const select = document.querySelector('div.familiar');
		ctrls = select.querySelectorAll('input, select');
   		
	    let isFormValid = true;

    	ctrls.forEach(ctrl => {
	    	if(ctrl.required){
		      	const isInputValid = this.showCtrlError(ctrl.id);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		  	}
	    });
	   
	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		
		if(control !== null){

			if (control.value === "") {
		        if(control !== null){
		            control.classList.add('error');
		        }
				res = false;
			} else{
				if(control !== null){
					if(control.required && control.className.includes('error')){
			        	control.classList.remove('error');
			    	}
		    	}
				res = true;
			}
		}

		return res;
	}

	render(){
		const {t} = this.props;
		return (
			<Modal show={this.state.show} onHide={this.handleClose}>
				<Modal.Header>
					<Modal.Title>Familiar Responsable</Modal.Title>
				</Modal.Header>
		        <Modal.Body >
		        	<div className="row">
			        	<div className="col-xs-12 form-group familiar">
			        		<div className="col-xs-12">
			        			<span>Nombre Completo</span>
			        			<input className="form-control" name="name" id="name" 
			        				value={this.state.name} autoFocus onChange={this.handleChange} 
			        				disabled={this.state.disabled}/>
			        		</div>
			        		<div className="col-xs-12">
			        			<span>Parentesco con el paciente</span>
			        			<select className="form-control" name="relationship" id="relationship" 
			        				value={this.state.relationship} onChange={this.handleChange} 
			        				disabled={this.state.disabled}>
			        				<option value="" disabled>Seleccionar...</option>
			                		{this.state.relationships.map((t)=>( 
				                  		<option key={t.id}  value={t.key} >{t.name} </option>
				                	))
				            }
			        			</select>
			        		</div>
			        		<div className="col-xs-12">
			        			<span>Domicilio</span>
			        			<input className="form-control" name="address" id="address" 
			        				value={this.state.address} onChange={this.handleChange} 
			        				disabled={this.state.disabled}/>
			        		</div>
			        		<div className="col-xs-12">
			        			<span>Localidad</span>
			        			<input className="form-control" name="state" id="state" 
			        				value={this.state.state} onChange={this.handleChange} 
			        				disabled={this.state.disabled}/>
			        		</div>
			        		<div className="col-xs-12">
			        			<div className="col-xs-12 col-sm-6" style={{paddingLeft:'0'}} >
				        			<span>Provincia</span>
				        			<input className="form-control" name="mpio" id="mpio" 
				        				value={this.state.mpio} onChange={this.handleChange} 
				        				disabled={this.state.disabled}/>
			        			</div>
			        			<div className="col-xs-12 col-sm-6" style={{paddingRight:'0'}} >
				        			<span>Código Postal</span>
				        			<input className="form-control" name="cp" id="cp" 
				        				value={this.state.cp} onChange={this.handleChange} 
				        				disabled={this.state.disabled}/>
			        			</div>
			        		</div>
			        		<div className="col-xs-12">
			        			<div className="col-xs-12 col-sm-6" style={{paddingLeft:'0'}} >
				        			<span>Tel. Celular</span>
				        			<input className="form-control" name="tel_cel" id="tel_cel" 
				        				value={this.state.tel_cel} onChange={this.handleChange} 
				        				disabled={this.state.disabled}/>
			        			</div>
			        			<div className="col-xs-12 col-sm-6" style={{paddingRight:'0'}} >
				        			<span>Tel. Casa</span>
				        			<input className="form-control" name="tel_casa" id="tel_casa" 
				        				value={this.state.tel_casa} onChange={this.handleChange} 
				        				disabled={this.state.disabled}/>
			        			</div>
			        		</div>
			        	</div>

			        	<fieldset className="col-xs-12">
			        		<legend>Datos Extras del Paciente</legend>
			        		<div className="col-xs-12">
			        			<div className="col-xs-12 col-sm-6">
			        				<span>Hemoglobina</span>
			        				<input type="number" name="hb" id="hb" value={this.state.hb} onChange={this.handleChange}
			        					className="form-control hour-input" />
			        			</div>
			        			<div className="col-xs-12 col-sm-6">
			        				<span>Hematocrito</span>
			        				<input type="number" name="hto" id="hto" value={this.state.hto} onChange={this.handleChange}
			        					className="form-control hour-input" />
			        			</div>
			        		</div>
			        	</fieldset>
		        	</div>
		        </Modal.Body>
		        <Modal.Footer style={{textAlign:'center'}}>
		        	<FlatButton primary={true} label={t('content.generics.buttons.save')}  onClick={this.handleSubmit}/>
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
		)
	}
}

export default translate('translations')(ModalFamiliar)